import * as React from "react"
import { Box, Card, Typography, Skeleton } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { statsData, isLoadingStats } from "./@signals"


function StatCard({ icon, label, value, subValue, color = 'primary.main', bgColor = '#f0f9ff' }) {
    return (
        <Card
            variant="outlined"
            sx={{
                p: 2,
                flex: 1,
                minWidth: 180,
                backgroundColor: bgColor,
                borderColor: 'transparent'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}>
                    <IconSeeker icon={icon} sx={{ color, fontSize: 20 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color, lineHeight: 1.2 }}>
                        {value}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {label}
                    </Typography>
                    {subValue && (
                        <Typography variant="caption" color="text.disabled" display="block" sx={{ fontSize: '0.65rem' }}>
                            {subValue}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Card>
    )
}

function StatCardSkeleton() {
    return (
        <Card variant="outlined" sx={{ p: 2, flex: 1, minWidth: 180 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Skeleton variant="rounded" width={40} height={40} />
                <Box>
                    <Skeleton variant="text" width={60} height={28} />
                    <Skeleton variant="text" width={80} height={16} />
                </Box>
            </Box>
        </Card>
    )
}


export default function StatsCards() {
    const stats = statsData.value
    const isLoading = isLoadingStats.value

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <StatCardSkeleton />
                <StatCardSkeleton />
                <StatCardSkeleton />
            </Box>
        )
    }

    if (!stats) return null

    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <StatCard
                    icon="box-open"
                    label="Total Candidates"
                    value={stats.total || 0}
                    subValue="Not-found products"
                    color="#6366f1"
                    bgColor="#eef2ff"
                />
                <StatCard
                    icon="fingerprint"
                    label="Unique Products"
                    value={stats.distinct_products || 0}
                    subValue="Distinct site+product"
                    color="#0891b2"
                    bgColor="#ecfeff"
                />
                <StatCard
                    icon="tags"
                    label="Brands"
                    value={stats.brands_count || 0}
                    subValue="With candidates"
                    color="#8b5cf6"
                    bgColor="#f5f3ff"
                />
                <StatCard
                    icon="store"
                    label="Sites"
                    value={stats.sites_count || 0}
                    subValue="With candidates"
                    color="#059669"
                    bgColor="#ecfdf5"
                />
            </Box>
        </Box>
    )
}
